module.exports = __webpack_public_path__ + "img/join-chair.9449d39a.png";